import moment from "moment";

const DATE_INPUT_FORMATS = ["YYYY-MM-DD", "MM-DD-YYYY"];

/**
 * Resolves the date window for the Staff Schedule report.
 *
 * When only one bound is entered the other mirrors it, so the report covers that
 * single day. Falling back to the current week for the missing bound produced an
 * inverted range (end < start) for any date outside this week, which silently
 * dropped schedules starting on the selected date.
 *
 * Only when both bounds are empty do we default to the current Mon-Fri week.
 */
export const resolveScheduleDateRange = (rawStart?: string | null, rawEnd?: string | null) => {
    const start = rawStart?.trim() || "";
    const end = rawEnd?.trim() || "";

    if (!start && !end) {
        const weekStart = moment().startOf("isoWeek");
        return {
            startDate: weekStart.format("YYYY-MM-DD"),
            endDate: weekStart.clone().add(4, "days").format("YYYY-MM-DD"),
        };
    }

    return {
        startDate: moment(start || end, DATE_INPUT_FORMATS).format("YYYY-MM-DD"),
        endDate: moment(end || start, DATE_INPUT_FORMATS).format("YYYY-MM-DD"),
    };
};

/**
 * Resolves the third evacuation address line for the Site Information report.
 *
 * Legacy records hold the evacuation name, street and city/state/zip in address
 * lines 1-3. Newer ones hold the name in EVAC_LOC and the city/state/zip in line
 * 2, and the site form only edits Location plus lines 1 and 2 — so line 3 is
 * left behind and can no longer be corrected or cleared from any screen.
 *
 * Print line 3 only while a record is still in the legacy shape. Once a site has
 * a Location, or has no address lines at all, whatever sits in line 3 is stale
 * (a leftover city from the site's previous evacuation address) and is dropped.
 */
export const resolveEvacuationLine3 = (
    location: any,
    addressLine1: any,
    addressLine2: any,
    addressLine3: any
) => {
    const hasText = (value: any) => `${value ?? ""}`.trim() !== "";

    if (hasText(location)) return "";
    if (!hasText(addressLine1) && !hasText(addressLine2)) return "";

    return addressLine3;
};

export const formatTime = (time: any) => {
    const [hour, minute] = time.split(":");
    return `${hour.trim().padStart(2, '0')}:${minute.trim()}`;
};

export const getUserData = () => {
    return JSON.parse(localStorage.getItem("userData") || "{}");
};